// extracted by mini-css-extract-plugin
export default {"wrapper":"_1IqhFdNqP3SthXTdFbO4zG","mainContent":"_1aPH9g0EUJbbWFsLscSSS9","mainContentCollaps":"_1SHxVnq4eaOm3LuDsqkPdA","errorMessage":"_2qTJSfzcYKV7u4pEe8DuVw"};